cafm.tab = {
    displayItemCount: function (tabItem, count, updateData) {

        var kIn = $('.k-link:first', tabItem);
        var itemCountEl = $('.tabItemCount', kIn);

        if (!itemCountEl.length) {

            itemCountEl = $('<span/>', {

                'class': 'tabItemCount'
            }).appendTo(kIn);
        }

        if (count > 0) {

            itemCountEl.text('({0})'.format(count));
        }
        else if (itemCountEl.length) {

            itemCountEl.remove();
        }

        if (updateData) {

            tabItem.data('count', count);
        }
    },
    updateListItemCount: function (list, itemKey, isInPanelBar) {

        if (!isStr(itemKey)) {

            itemKey = cafm.enums.getEnumKey(cafm.enums.Navigatable, itemKey);
        }

        var itemEl;

        if (isMobile || isInPanelBar) {

            itemEl = list.closest('li.k-item[data-key="{0}"]'.format(itemKey));
        }
        else {

            var k = list.closest('.k-content.k-state-active'.format(itemKey)), tabs = list.closest('.k-tabstrip');
            itemEl = tabs.find('> ul > [data-key="{0}"]'.format(itemKey));
        }

        var count = list.data('unfilteredTotal');

        if (!cafm.util.isNum(count)) {

            count = list.getListItemCount();
        }

        cafm.tab.displayItemCount(itemEl, count, true);
    }
}